import doubleDigitize from 'src/filters/doubleDigitize';

function formatTimeWithSec(value) {
  if (!value) return '';
  const datetime = new Date(value);
  const hours = datetime.getHours();
  const minutes = datetime.getMinutes();
  const seconds = datetime.getSeconds();
  return `${doubleDigitize(hours)}:${doubleDigitize(minutes)}:${doubleDigitize(seconds)}`;
}

export default formatTimeWithSec;
